import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import AppHeader from "../../components/AppHeader";
import { useTheme } from "../../contexts/ThemeContext";

const AccountLayout = () => {
  const { isDark } = useTheme();
  return (
    <div
      className={
        `min-h-screen flex flex-col transition-colors duration-250 ` +
        (isDark ? 'bg-gray-900' : 'bg-[#F8F9FA]')
      }
    >
      {/* Top Header */}
      <AppHeader />

      {/* Body */}
      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar — fixed height, independent scroll */}
        <div className="sticky top-0 h-[calc(100vh-64px)] overflow-y-auto flex-shrink-0 dark:bg-gray-800">
          <Sidebar />
        </div>

        {/* Page Content — scrolls independently */}
        <main className="flex-1 overflow-y-auto h-[calc(100vh-64px)] bg-white dark:bg-gray-900 transition-colors duration-250">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AccountLayout;
